import React from "react";
import Translation from "../i18n";

class QuestionBullets extends React.Component {

    constructor(props) {
        super(props);
        this.goToQuestion = this.goToQuestion.bind(this);
        this.returnTrue = this.returnTrue.bind(this);
    }

    goToQuestion(question) {
        this.props.goToQuestion(question);
    }

    returnTrue() {
        return true;
    }

    render() {

        const length = this.props.questions.length;
        const bullets = [];
        for (let i = 0; i < length; i++) {
            bullets.push(<button type="button" key={'questionBullet' + i} className={'question-bullet' + (this.props.seenQuestions >= parseInt(i) ? ' seen ' : '') + (this.props.currentQuestion === i ? ' active' : '')} onClick={this.props.seenQuestions >= parseInt(i) ? () => this.goToQuestion(i) : () => this.returnTrue()} >{i}</button>)
        }

        return (
            <>
                <div className="container question-bullets">
                    {bullets}
                </div>
                <span className="d-block text-center question-indicator"><Translation i18n="question" /> {(this.props.currentQuestion + 1)}</span>
            </>
        );
    }
}

export default QuestionBullets;
